type CancelTimeoutFn = () => void;

/**
 * Sets a timeout and returns a function to cancel the timeout
 * @param callback Specifies a function to execute after a specified number of milliseconds
 * @param millisecondsTimeout Specifies the number of milliseconds before the function is executed
 * @returns Function to cancel the timeout
 */
export default function startTimeout(callback: () => void, millisecondsTimeout: number): CancelTimeoutFn {
    const timerId = setTimeout(callback, millisecondsTimeout);
    return () => clearTimeout(timerId);
}
